<template>
  <v-container fluid>
    <v-row no-gutters class="d-flex justify-space-between mt-5 mb-1">
      <h1 class="page-title">Download LHI</h1>
    </v-row>
    <v-row>
      <v-col cols="12" md="4">
        <h7>No. Tiket JAGA</h7>
        <v-text-field v-model="searchNoJaga" class="mb-2 white mr-1" hide-details="auto" dense placeholder="Cari No. Tiket JAGA"
          label="" outlined></v-text-field>
      </v-col>
      <v-col cols="12" md="4">
        <h7>Lokasi Kejadian</h7>
        <v-text-field v-model="searchLokasi" class="mb-2 white mr-1" hide-details="auto" dense
          placeholder="Cari Lokasi Kejadian" label="" outlined></v-text-field>
      </v-col>
      <v-col cols="12" md="4">
        <h7>Status</h7>
        <v-select v-model="searchStatus" class="mb-0 white mr-1" hide-details="auto" dense placeholder="Semua"
          :items="infoStatus" item-text="paramName" item-value="paramCd" outlined></v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="4">
        <h7>Tanggal Selesai Investigasi</h7>
        <v-menu ref="menuFrom" v-model="menuFrom" :close-on-content-click="false" transition="scale-transition"
          min-width="290px">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="searchDateFrom" label="" prepend-inner-icon="mdi-calendar" v-bind="attrs" v-on="on"
              readonly outlined dense hide-details="auto" class="mb-0 white mr-1" placeholder="Dari"
              clearable></v-text-field>
          </template>
          <v-date-picker v-model="investigationDateFromPicker" no-title scrollable @input="pickDateForm"></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" md="4">
        <h7 class="label-text-field white--text" color="primary">""</h7>
        <v-menu ref="menuTo" v-model="menuTo" :close-on-content-click="false" transition="scale-transition"
          min-width="290px">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="searchDateTo" label="" prepend-inner-icon="mdi-calendar" v-bind="attrs" v-on="on"
              readonly outlined dense hide-details="auto" class="mb-0 white mr-1" placeholder="Sampai"
              clearable></v-text-field>
          </template>
          <v-date-picker v-model="investigationDateToPicker" no-title scrollable @input="pickDateTo"></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" md="4">
        <h7 class="label-text-field white--text" color="primary">""</h7>
        <v-row cols="12" md="4" class="text--right">
          <v-btn @click="loadData" class="evelation-0 text-capitalize ml-3" cols="1" color="primary">
            <span class="white--text">Cari</span>
          </v-btn>
          <v-btn @click="reset" depressed outlined color="primary" cols="1"
            class="elevation-0 text-capitalize ml-1 primary--text">
            <span class="orange--text">Reset</span>
          </v-btn>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="mb">
      <v-col>
        <v-card>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-data-table class="tableData" :headers="headers" :items="dataList" :server-items-length="totalData" :items-per-page="5" 
                  :header-props="{ sortIcon: null }" @update:options="updateTableOptions" disable-sort mobile-breakpoint="0">
                  <template v-slot:item="data">
                    <tr class="trReview" :key="data.item.fraudId">
                      <td class="tdReview orange--text">
                        {{ data.item.jagaNo }}
                      </td>
                      <td class="tdReview">
                        {{ data.item.investigationEndDtStr }}
                      </td>
                      <td class="tdReview">
                        {{ data.item.lokasiKejadian }}
                      </td>
                      <td class="tdReview">
                        {{ data.item.reportStatusStr }}
                          <!-- {{ data.item.reportStatus }} -->
                      </td>
                      <td align="center" class="tdReview">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn small text class="text-capitalize black--text px-0" v-on="on" v-bind="attrs"
                              @click="handleDownloadDataLhi(data.item.fraudId)"
                              v-if="isShowPrintButton(data.item.reportStatus)">
                              <v-icon aria-hidden="false" style="font-size: 20px"
                                color="#F5821F">mdi-printer-outline</v-icon>
                            </v-btn>
                          </template>
                          <span>Print</span>
                        </v-tooltip>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapActions } from "vuex";
import moment from "moment";

export default {
  data() {
    return {
      page: 1,
      itemsPerPage: 5,
      headers: [
        {
          text: "No. Tiket JAGA",
          align: "center",
          width: "150px",
        },
        {
          text: "Tanggal Selesai Investigasi",
          align: "center",
          width: "180px",
        },
        {
          text: "Lokasi Kejadian",
          align: "center",
          width: "158px",
        },
        {
          text: "Status",
          align: "center",
          width: "158px",
        },
        {
          text: "Tindakan",
          align: "center",
          width: "200px",
        },
      ],
      searchNoJaga: null,
      searchLokasi: null,
      searchDateFrom: null,
      searchDateTo: null,
      searchStatus: null,
      menuFrom: null,
      menuTo: null,
      investigationDateFromPicker: null,
      investigationDateToPicker: null,
      totalData: null,
      dataList: [],
      infoStatus: [],
    };
  },

  mounted() {
    this.loadStatus();
  },

  created() {
    this.requiredFeature('DOWNLOAD_LHI')
    this.changeTitleApp("Download LHI");
  },

  methods: {
    ...mapActions([
      "changeTitleApp",
      "searchLHI",
      "getParameterByParamType",
      "downloadDataLhi",
    ]),

    reset: function () {
      this.searchNoJaga = "";
      this.searchLokasi = "";
      this.searchDateFrom = "";
      this.searchDateTo = "";
      this.searchStatus = "";
      this.loadData();
    },

    loadData() {
      let page = this.page;
      let itemsPerPage = this.itemsPerPage;

      this.searchLHI({
        jagaNo: this.searchNoJaga,
        lokasiKejadian: this.searchLokasi,
        investigationStartDate: this.searchDateFrom ? moment(this.searchDateFrom, "DD-MMM-YYYY").format("yyyy-MM-DD") : "",
        investigationEndDate: this.searchDateTo ? moment(this.searchDateTo, "DD-MMM-YYYY").format("yyyy-MM-DD") : "",
        status: this.searchStatus,
        page: page,
        itemsPerPage: itemsPerPage,
      })
      .then((response) => {
        console.log("response.data.data", response.data.data);
        this.dataList = response.data.data;
        this.totalData = response.data.countData;
      })
      .catch((err) => {
        this.dataList = [];
        this.$helpers.handleError(err);
      });
    },

    handleDownloadDataLhi(fraudId) {
      this.downloadDataLhi(fraudId)
        .then((resp) => {
          console.log("susccess", resp);
        })
        .catch((err) => {
          this.$helpers.handleError(err);
          console.log("error", err.response);
        });
    },

    loadStatus() {
      this.getParameterByParamType({
        paramType: "REPORT_STATUS",
      })
      .then((resp) => {
        this.infoStatus = resp.data.data.filter(
          (item) => item.paramCd == "REPORT_STATUS_CLOSED" ||
                    item.paramCd == "REPORT_STATUS_DELEGATE_REVIEWER" ||
                    item.paramCd == "REPORT_STATUS_IN_SANCTION" ||
                    item.paramCd == "REPORT_STATUS_INVESTIGATION_RE_SUBMIT" ||
                    item.paramCd == "REPORT_STATUS_INVESTIGATION_SUBMIT" ||
                    item.paramCd == "REPORT_STATUS_KF_DONE" ||
                    item.paramCd == "REPORT_STATUS_KF_OUTSTANDING" ||
                    item.paramCd == "REPORT_STATUS_REVIEWED" ||
                    item.paramCd == "REPORT_STATUS_RETURN_AFM_REVIEWER" ||
                    item.paramCd == "REPORT_STATUS_RE_INVESTIGATE"

        );
      })
      .catch((err) => {
        this.$helpers.handleError(err);
      });
    },

    pickDateForm() {
      this.menuFrom = false;
      this.searchDateFrom = moment(this.investigationDateFromPicker).format(
        "DD-MMM-YYYY"
      );
    },

    pickDateTo() {
      this.menuTo = false;
      this.searchDateTo = moment(this.investigationDateToPicker).format(
        "DD-MMM-YYYY"
      );
    },

    updateTableOptions(options) {
      this.page = options.page
      this.itemsPerPage = options.itemsPerPage

      this.loadData();
    },

    isShowPrintButton(reportStatus) {
      const hiddenStatus = ["REPORT_STATUS_RETURN_AFM_REVIEWER", "REPORT_STATUS_RE_INVESTIGATE"];
      return !hiddenStatus.includes(reportStatus);
    },
  },

  computed: {
    
  },
};
</script>


<style src="./DownloadLHI.scss" lang="scss" />


